import { ICommand, IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { STCSchedulingConfigModel } from '../models/stc_scheduling_config_model';
import { StcCustomContentsModel } from '../models/stc_custom_contents_model';
import { GetSchedulingConfigCommand } from './get_scheduling_config_command';

export type GetScheduleAppointmentLabelCommand = (defaultLabel: string) => ng.IPromise<string>;

angular
  .module('data-ng-custom-text')
  .factory(
    'getScheduleAppointmentLabelCommand',
    (
      $q: ng.IQService,
      defineCommandORM: IDefineCommand,
      appConfigModel: any,
      ngStcSchedulingConfigModel: STCSchedulingConfigModel,
      ngStcCustomContentsModel: StcCustomContentsModel,
      loadStcCustomContentsCommand: ICommand,
      getSchedulingConfigCommand: GetSchedulingConfigCommand
    ) =>
      defineCommandORM('getScheduleAppointmentLabelCommand', (deferred, defaultLabel: string) => {
        let buttonLabel = defaultLabel;
        const APPOINTMENT_SCHEDULE_FEATURE_TOGGLE = 'model.member_features.ssccampus-appointment_scheduling';
        const SCHEDULE_BUTTON_TEXT = 'student_scheduling.student_scheduler_button_text';
        const schedulingFeatureOn = _4.get(appConfigModel, APPOINTMENT_SCHEDULE_FEATURE_TOGGLE, false);
        const schedulingConfigNotResolved = _4.isUndefined(
          _4.get(ngStcSchedulingConfigModel.read(), 'v3_student_scheduler_flag')
        );
        let promise = $q.resolve();

        if (schedulingConfigNotResolved && schedulingFeatureOn) {
          promise = getSchedulingConfigCommand();
        }

        promise.then(() => {
          const v3Enabled = _4.get(ngStcSchedulingConfigModel.read(), 'v3_student_scheduler_flag', false);
          const shouldGetCustomContents =
            _4.isUndefined(ngStcCustomContentsModel.read().student_scheduling) && v3Enabled;

          if (!shouldGetCustomContents) {
            return deferred.resolve(_4.get(ngStcCustomContentsModel.read(), SCHEDULE_BUTTON_TEXT, defaultLabel));
          }
          return loadStcCustomContentsCommand().then(() =>
            deferred.resolve(_4.get(ngStcCustomContentsModel.read(), SCHEDULE_BUTTON_TEXT, defaultLabel))
          );
        });
      })
  );



// WEBPACK FOOTER //
// ./app/vendor/data-ng-custom-text/src/commands/get_schedule_appointment_label_command.ts